/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - Munich, London 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [emoji-text.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 23.02.20, 16:47
 */
import emojione from 'emojione';
import DOMPurify from 'dompurify/dist/purify'
import React, {useEffect, useRef, useState} from 'react';
import {marked} from "marked";
import {cn} from "../util/text-utils";
import {NONE_STATUS, PENDING_STATUS, SUCCESS_STATUS} from "../../actions";

// @Deprecated
const EmojiText = ({children, className, sanitize = true, ...otherProps}) => {
    const [status, setStatus] = useState(NONE_STATUS);
    const richTextRef = useRef(null);

    useEffect(() => {
        if(richTextRef.current) {
            setStatus(PENDING_STATUS);
            const sanitized = DOMPurify.sanitize(
                marked.parse(richTextRef.current.innerHTML, { breaks: true }),
                {USE_PROFILES: {html: true}}
            );

            richTextRef.current.innerHTML = emojione.toImage(sanitized);
            setStatus(SUCCESS_STATUS);
        }

    }, [children]);

    return <div className={cn('emoji-text', [className])} ref={richTextRef} {...otherProps}>
        {children}
    </div>
};

export const EmojiText2 = ({text, className, ...otherProps}) => {
    const [status, setStatus] = useState(NONE_STATUS);
    const richTextRef = useRef(null);

    useEffect(() => {
        if(richTextRef.current) {
            setStatus(PENDING_STATUS);
            const sanitized = DOMPurify.sanitize(
                marked.parse(text, { breaks: true }),
                {USE_PROFILES: {html: true}}
            );
            richTextRef.current.innerHTML = emojione.toImage(sanitized);
            setStatus(SUCCESS_STATUS);
        }

    }, [text]);

    return <div className={cn('emoji-text', [className])} ref={richTextRef} {...otherProps}/>
};

export default EmojiText;